import { useSelector } from 'react-redux';
import { availableLanguages } from '../marketplace-custom-config';
import { useMemo } from 'react';
const languages = Array.from(availableLanguages);

export function useNativeLang() {
  const userNativeLang = useSelector(state => state.ui.userNativeLang);
  const alternativeLangs = useMemo(() => languages.filter(lang => lang !== userNativeLang), [
    userNativeLang,
  ]);
  return { userNativeLang, alternativeLangs };
}
